import React from 'react';
import Grid from '@mui/material/Grid';
import NumberCircle from 'src/base/texts/NumberCircle';
import { P } from 'src/base/texts/P';

interface FeatureStepProps {
  number: string;
  text: string;
}

export function FeatureStep(props: FeatureStepProps): JSX.Element {
  return (
    <>
      <style>
        {`
          @media screen and (max-width: 768px) {
            .feature-step-text {
              text-align: center;
              margin-top: 12px !important;
              margin-left: auto;
              margin-right: auto;
            }
          }
        `}
      </style>
      <Grid
        container
        className="justify-content-md-center"
        style={{ marginTop: 40, justifyContent: 'center' }}
      >
        <Grid item sm style={{ maxWidth: 100 }}>
          <NumberCircle>{props.number}</NumberCircle>
        </Grid>
        <Grid item sm style={{ display: 'flex', maxWidth: 500 }}>
          <div
            style={{
              marginTop: 'auto',
              marginBottom: 'auto',
            }}
          >
            <P>{props.text}</P>
          </div>
        </Grid>
      </Grid>
    </>
  );
}
